module.exports = __webpack_public_path__ + "img/01.f2542bd8.png";